import { useEffect, useState } from 'react'

// แท็บที่ถูกซ่อน (สลับแท็บ / ย่อหน้าต่าง) เบราว์เซอร์หน่วงตัวจับเวลาและไม่โหลดภาพ
// สิ่งที่วัดเวลาภาพต้องรอจนแท็บกลับมาแสดง ไม่งั้นสรุปผิดว่ากล่องไม่ส่งภาพ
export const isPageVisible = () => document.visibilityState !== 'hidden'

export default function usePageVisible() {
  const [visible, setVisible] = useState(isPageVisible)

  useEffect(() => {
    const onChange = () => setVisible(isPageVisible())
    document.addEventListener('visibilitychange', onChange)
    return () => document.removeEventListener('visibilitychange', onChange)
  }, [])

  return visible
}
